module.exports = __webpack_public_path__ + "img/404_green.20c59312.png";